import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { bindActionCreators } from "redux";

import { ADD_TILE_POST } from "../constants/urls";
import {
  tilesErrorMessageRaised,
  tilesRestartMessages,
  tilesSuccessMessageRaised,
} from "../actions/tileActions";
import { addDocument } from "../actions/tileActions";
import axios from "axios";

const FormForSaveResults = ({
  positiveButton,
  negativeButton,
  positiveAction,
  negativeAction,
  addDocument,
  setAskAQuestionModal,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const getTopicFromStore = sessionStorage.getItem("TOPIC_SEARCHTAGS");
  const documentTitle = localStorage.getItem("singleDocumentTitleName");
  const documentID = localStorage.getItem("singleTopicId");
  const referenceID = sessionStorage.getItem("reference_id");

  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    nameTheTile: "",
    tileAudience: "",
    rootFolder: "",
    textareaInput: "",
  });
  const checkAI_Request = JSON.parse(
    sessionStorage.getItem("commonAI_REQUEST")
  );

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const userToken = useSelector((state) => {
    return state.configReducer.userToken;
  });

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const dataArr = useSelector((state) => {
    return state.tileReducer.tiles;
  });

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const AI_RESPONSE_FromStore = useSelector((state) => {
    return state.askQuestionReducer;
  });

  let filteredDataArr = dataArr?.filter(
    (item) => item.TILE_TYPE === "Group of tiles"
  );

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleContentEditableBlur = (event) => {
    const htmlContent = event.target.innerHTML;
    setFormData({
      ...formData,
      textareaInput: htmlContent,
    });
  };

  let bodyFormData = new FormData();
  bodyFormData.append("usertoken", userToken);
  bodyFormData.append("tile_name", formData?.nameTheTile);
  bodyFormData.append("tile_type", "Text");
  bodyFormData.append("tile_value", formData.textareaInput);
  bodyFormData.append("tile_audience", formData.tileAudience);
  bodyFormData.append("topic_document_id", formData.rootFolder);

  const asString = new URLSearchParams(bodyFormData).toString();

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);

    if (checkAI_Request) {
      axios
        .post(ADD_TILE_POST, asString, config)
        .then((response) => {
          dispatch(tilesSuccessMessageRaised(response?.data));
          sessionStorage.setItem("success", true);
          dispatch(
            tilesErrorMessageRaised(response?.err?.data && response.err.data)
          );
        })
        .catch((error) => {
          console.log(error);
          dispatch(tilesErrorMessageRaised(error));
        });
    } else {
      addDocument(
        userToken,
        documentID,
        getTopicFromStore ? getTopicFromStore : documentTitle,
        referenceID ? referenceID : id,
        formData?.nameTheTile,
        "Text",
        formData.tileAudience
      );
      sessionStorage.setItem("success", true);
    }
    setAskAQuestionModal(false);
  };

  const arr = [
    {
      description: "Please select",
      value: "",
    },
    {
      description: t("privateTile"),
      value: "private",
    },
    {
      description: t("publicTile"),
      value: "public",
    },
  ];

  const rootArr = [
    { description: "Please select", value: "" },
    {
      description: getTopicFromStore ? getTopicFromStore : documentTitle,
      value: id,
    },
  ];

  if (filteredDataArr.length > 0) {
    filteredDataArr.forEach((item) => {
      rootArr.push({
        description: item.TILE_NAME,
        value: item.TILE_NAME,
      });
    });
  }

  let response = AI_RESPONSE_FromStore.response;
  let data = sessionStorage.getItem("AIQuestion");
  const combinedString = `<b>${data}</b><br />${response}`;

  useEffect(() => {
    const sanitizedDefaultValue = DOMPurify.sanitize(combinedString, {
      ADD_TAGS: ["img", "a"],
      ADD_ATTR: ["target"],
      FORBID_TAGS: ["script"],
      // eslint-disable-next-line no-useless-escape, prettier/prettier
      ALLOWED_URI_REGEXP:
        // eslint-disable-next-line no-useless-escape
        /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    });

    setFormData({
      ...formData,
      textareaInput: sanitizedDefaultValue,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let isDisabled =
    formData.nameTheTile === "" ||
    formData.tileAudience === "" ||
    formData.rootFolder === "" ||
    formData.textareaInput === "";

  return (
    <Container>
      <Row>
        <Col md={6}>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            // id="save-results-form"
            id="ask-a-question-form"
          >
            <Form.Group
              controlId={t("nameTheTile")}
              className="add-news-full-width-fields-group field form-group"
            >
              <Form.Label style={{ fontWeight: "bold" }} className="form-label">
                {t("nameTheTile")}
              </Form.Label>
              <Form.Control
                className="results-input"
                // style={{ width: "538px", height: "56px" }}
                type="text"
                placeholder={t("nameTilePlaceholder")}
                name="nameTheTile"
                value={formData.textInput}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Label style={{ fontWeight: "bold" }}>
              Tile audience
            </Form.Label>
            <Form.Control
              className="select form-group custom-select results-input"
              as="select"
              name="tileAudience"
              value={formData.selectInput}
              onChange={handleInputChange}
              required
            >
              {arr.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.description}
                </option>
              ))}
            </Form.Control>

            <Form.Label style={{ fontWeight: "bold" }}>Root folder</Form.Label>
            <Form.Control
              className="select form-group custom-select results-input"
              as="select"
              name="rootFolder"
              value={formData.secondSelectInput}
              onChange={handleInputChange}
              required
            >
              {rootArr.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.description}
                </option>
              ))}
            </Form.Control>
            <div
              className="save-results-textarea-field results-input"
              contentEditable="true"
              onBlur={handleContentEditableBlur}
              dangerouslySetInnerHTML={{ __html: formData.textareaInput }}
            />
            <div className="custom-footer">
              <Button
                onClick={negativeAction}
                className="fs-14 custom-modal-btn apply-bg-white-color  modal-negative-button"
              >
                {negativeButton}
              </Button>
              <Button
                type="submit"
                disabled={isDisabled}
                onClick={positiveAction}
                className={
                  "modal-positive-button apply-bg-approx-analog-color fs-14 custom-modal-btn"
                }
              >
                {positiveButton}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    tileSuccessMessage: state.tileReducer.tileSuccessMessage,
    tileErrorMessage: state.tileReducer.tileErrorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    tilesRestartMessages: bindActionCreators(tilesRestartMessages, dispatch),
    addDocument: bindActionCreators(addDocument, dispatch),
  };
};

FormForSaveResults.propTypes = {
  negativeButton: PropTypes.string,
  positiveButton: PropTypes.string,
  positiveAction: PropTypes.func,
  negativeAction: PropTypes.func,
  tileSuccessMessage: PropTypes.string.isRequired,
  tileErrorMessage: PropTypes.string.isRequired,
  addDocument: PropTypes.func.isRequired,
  setAskAQuestionModal: PropTypes.func,
};
FormForSaveResults.defaultProps = {
  addTileForSaveResults: () => {},
  tileSuccessMessage: "",
  tileErrorMessage: "",
  tilesRestartMessages: () => {},
  addDocument: () => {},
  setAskAQuestionModal: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(FormForSaveResults);
